import $ from 'jquery';
import './libs/jquery.inview';
import './libs/slick';
import './libs/remodal';
import './libs/lightbox.min';
$(function(){
	$('body').addClass('-init');
	$('a[href^="#"]').on('click',function(){
		var speed = 500;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$("html, body").animate({scrollTop:position}, speed, "swing");
		return false;
	});
	$('.js-navBtn,.navBlock a').on('click', function () {
		$('.navBlock').fadeToggle();
		$('body').toggleClass('-lock');
	});
	//inview
	$('.js-iv').on('inview', function() {
		$(this).addClass('-viewed');
	});
	$('.js-itemTxtMore').on('click', function () {
		$(this).parent().next().slideDown();
		$(this).remove();
	});

	$('.js-kvSld').slick({
		fade:true,
			autoplay:true,
			pauseOnHover:false,
			autoplaySpeed:5000,
			speed:1500,
			arrows: false,
			dots:true
	});

	//info
	$('.-js-infoCnt__spImgSld').slick({
		fade:true,
			autoplay:true,
			pauseOnHover:false,
			autoplaySpeed:5000,
			speed:1500,
			arrows: false,
			dots:true
	});

	//TOPICスライド
	if ($('.topicSldSec').length > 0) {

		$('.topicSldSec').each(function () {
			var $sec = $(this), $sld = $('.js-topicSld', $sec);
			$y = window.scrollY;

			$sld.slick({
				//fade:true,
				centerMode: true,
				// autoplay:true,
				pauseOnHover:false,
				autoplaySpeed:5000,
				speed:1500,
				arrows: false,
				dots: true,
				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				responsive: [
					{
						breakpoint: 767,
						settings: {
							fade:true,
							slidesToShow: 1,
							slidesToScroll: 1,
							infinite: true,
							arrows: true,
							dots: true
						}
					}
				]
			});
			$('.js-topicSld-prev',$sec).on('click', function () {
				$sld.slick('slickPrev');
			});
			$('.js-topicSld-next',$sec).on('click', function () {
				$sld.slick('slickNext');
			});

			$(window).on('scroll', function () {
				if ($y+window.innerHeight > $sec.offset().top) {
					$sld.slick('slickPlay');
				}
			});

		});
	}

	if ($('.storyPage,.topicSinglePage').length > 0) {
		$('.postBlock .-ttl').each(function () {
			var $txt = $(this).text();
			console.log($txt);
			$(this).empty();
			$(this).html('<span class="-in">' + $txt + '</span>');
		});
	}

	if ($('.js-listPickup').length > 0) {
		$('.js-listPickup').slick({
			fade: true,
			autoplay: true,
			pauseOnHover: false,
			autoplaySpeed: 5000,
			speed: 1200,
			arrows: false,
			dots: true,
			infinite: true,
			responsive: [
				{

					breakpoint: 768,
					settings: {
						centerMode: true,
        		centerPadding: '0px',
						fade: false,
						slidesToShow: 1,
						slidesToScroll: 1,
					}
				}
			]
		});
	}

	function textTrim() {
		var selector = $('.js-trimTxt')
		var wordCount = 35;
		var clamp = '…';

		for (var i = 0; i < selector.length; i++) {
			if (selector[i].innerText.length > wordCount) {
				var str = selector[i].innerText;
				str = str.substr(0, (wordCount - 1));
				selector[i].innerText = str + clamp;
			}
		}
	}
	textTrim();

	function textTrimPu() {
		var selector = $('.js-trimTxtPu')
		var wordCount = 90;
		var clamp = '…';

		for (var i = 0; i < selector.length; i++) {
			if (selector[i].innerText.length > wordCount) {
				var str = selector[i].innerText;
				str = str.substr(0, (wordCount - 1)); 
				selector[i].innerText = str + clamp;
			}
		}
	}
	textTrimPu();


	//ショップテンプレート story無
	if ($('.shopTemp').length > 0) {
		if ($('.storySec').length < 1) {
			$('body').addClass('-noStory');
		}
	}

	if ($('.js-txtmoreBtn').length > 0) {
		$('.js-txtmoreBtn').on('click', function () {
			$(this).hide();
			$('.js-txtmore').slideDown();
		});
	}


	$('.infoSec .infoCnt').each(function () {
		var $cntBox = $(this);
		if ($('.infoCnt__kv', $cntBox).length < 1) {
			$cntBox.addClass('-noKv');
		}

		if ($('infoCnt__imgListBlock', $cntBox).length < 1) {
			$cntBox.addClass('-noImgList');
		}
	});

	$('.itemInfoBox').each(function () {
		var $cntBox = $(this);
		if ($('.itemInfoBox__img', $cntBox).length < 1) {
			$cntBox.addClass('-noImg');
		}
	});


	$('.itemSec').each(function () {
		var $sec = $(this);
		if ($('.itemBox', $sec).length < 1 && $('.itemInfoBox', $sec).length < 1) {
			$sec.addClass('-disno');
		}

	});

	$('.imgListPc').each(function () {
		var $val = $('li', this).length;
		$(this).addClass('-item' + $val);
	})

	$('.itemList').each(function () {
		var $val = $('.itemBox', this).length;
		$(this).addClass('-item' + $val);
	})

	//brwsrEvt
	var $wH,$brwsw,$y;

	brwsrEvt();
	$(window).on('resize',function() {
	    brwsrEvt();
	});
	$(window).on('scroll',function () {
		brwsrEvt();
	});

	function brwsrEvt(){
		$wH = window.innerHeight,
		$brwsw = window.innerWidth,
		$y = window.scrollY;

		if ($y > $wH) {
			$('body').addClass('-kvScrl');
		} else {
			$('body').removeClass('-kvScrl');
		}
	}
});